if (!customElements.get('dd0-icon-bar')) {
  customElements.define('dd0-icon-bar', class extends HTMLElement {
    connectedCallback() {
      this._controller = new AbortController();
      const { signal } = this._controller;
      this._track  = this.querySelector('.dd0-ib__track');
      this._cards  = Array.from(this.querySelectorAll('.dd0-ib__card'));
      this._dots   = Array.from(this.querySelectorAll('.dd0-ib__dot'));
      this._arrows = this.querySelectorAll('.dd0-ib__arrow');
      this._current = 0;
      this._count = this._cards.length;
      this._timer = null;
      this._speed = (parseInt(this.dataset.speed, 10) || 3) * 1000;
      this._mq = window.matchMedia('(max-width: 749px)');
      this._reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this._track || this._count === 0) return;

      this._dots.forEach((dot, i) => dot.addEventListener('click', () => {
        this._goTo(i);
        this._restartAutoplay();
      }, { signal }));

      if (this._arrows.length === 2) {
        this._arrows[0].addEventListener('click', () => { this._goTo(this._current - 1); this._restartAutoplay(); }, { signal });
        this._arrows[1].addEventListener('click', () => { this._goTo(this._current + 1); this._restartAutoplay(); }, { signal });
      }

      this._track.addEventListener('scroll', this._onScroll.bind(this), { passive: true, signal });

      window.addEventListener('resize', this._onResize.bind(this), { signal });

      this._syncDots();

      if (this.dataset.autoplay === 'true') {
        this._startAutoplay();
        this.addEventListener('pointerenter', () => this._stopAutoplay(), { signal });
        this.addEventListener('pointerleave', () => this._startAutoplay(), { signal });
        this.addEventListener('focusin', () => this._stopAutoplay(), { signal });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this._startAutoplay();
        }, { signal });
        this._onMqChange = () => (this._mq.matches ? this._startAutoplay() : this._stopAutoplay());
        this._mq.addEventListener('change', this._onMqChange, { signal });
      }
    }

    disconnectedCallback() {
      this._controller?.abort();
      this._stopAutoplay();
      if (this._onMqChange) this._mq.removeEventListener('change', this._onMqChange);
    }

    // Distance between the start of one card and the next (card width + gap).
    _step() {
      if (this._cards.length < 2) return this._track.offsetWidth || 1;
      return (this._cards[1].offsetLeft - this._cards[0].offsetLeft) || this._cards[0].offsetWidth;
    }

    // Number of cards visible at once in the viewport.
    _perView() {
      return Math.max(1, Math.round(this._track.clientWidth / this._step()));
    }

    // Highest reachable scroll index (cards − visible per view).
    _maxIndex() {
      return Math.max(0, this._count - this._perView());
    }

    _onResize() {
      this._syncDots();
      const max = this._maxIndex();
      if (this._current > max) this._goTo(max);
    }

    // Hide pagination dots that don't map to a real scroll stop.
    _syncDots() {
      const max = this._maxIndex();
      this._dots.forEach((dot, i) => { dot.hidden = i > max; });
      this._updateDots(Math.min(this._current, max));
    }

    _goTo(index) {
      const span = this._maxIndex() + 1;
      this._current = ((index % span) + span) % span;
      this._track.scrollTo({ left: this._step() * this._current, behavior: 'smooth' });
      this._updateDots(this._current);
    }

    _onScroll() {
      const step = this._step();
      if (!step) return;
      const index = Math.round(this._track.scrollLeft / step);
      if (index !== this._current) {
        this._current = index;
        this._updateDots(index);
      }
    }

    _updateDots(index) {
      this._dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    _startAutoplay() {
      if (!this.isConnected || this.matches(':hover') || this.contains(document.activeElement)) return;
      if (this.dataset.autoplay !== 'true') return;
      if (!this._mq.matches || this._reduceMotion.matches) return; // mobile only, honour reduced motion
      this._stopAutoplay();
      this._timer = setInterval(() => {
        if (!document.hidden) this._goTo(this._current + 1);
      }, this._speed);
    }

    _stopAutoplay() {
      if (this._timer) {
        clearInterval(this._timer);
        this._timer = null;
      }
    }

    _restartAutoplay() {
      if (this._timer) this._startAutoplay();
    }
  });
}
